import { api } from './api';
import axios from 'axios';

interface GetTeamsParams {
  url: string;
}

interface Team {
  id: string;
  name: string;
}

export interface GetTeamsResponse {
  teams: Team[];
  links: {
    next: string;
  };
}
export const getTeams = async (params: GetTeamsParams) => {
  const response = await api.get<GetTeamsResponse>(params.url);
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return response.data;
};
